// constants
import { salesWebsiteUrl } from "../helpers/axios/config";

// sideDrawer children paths
const SIDE_DRAWER_CHILDREN_PATHS = {
  salesDashboard: "/sales-dashboard",
  salesRunsheet: "/sales-runsheet",
  salesVisits: "/sales-visits",
  telesalesRunsheet: "/telesales-runsheet",
  salesTracking: "/sales-tracking",
  salesAgents: "/sales-agents",
  createSalesAgent: "/sales-agent/create",
  editSalesAgent: (agentId = ":agentId") => `/sales-agent/${agentId}/edit`,

  vendorSupportPricing: "/vendor/vendor-support-pricing",
  repriceNeededOrders: "/vendor/reprice-needed-orders",
  acceptedOrders: "/vendor/accepted-orders",

  opsNeedSupport: "/tower/ops-need-support",
  mechanicNeedSupport: "/tower/mechanic-need-support",
  towerHistory: "/tower/tower-history",

  courierAssignmentAcceptOrders:
    "/operations/courier-assignment-accepted-orders",
  courierAssignment: "/operations/courier-assignment-fulfilled-orders",
  reallocationGroups: "operations/reallocation-groups",
  availableCouriers: "/operations/available-couriers",
  polygons: "/operations/polygons",
  polygonGroups: "/operations/polygon-groups",
  vehicles: "/operations/vehicles",
  courierAssignmentTransferOrders:
    "/operations/courier-assignment-transfer-orders",
  pendingCourierDeficits: "/operations/pending-courier-deficits",
  courierTasks: "/operations/courier-tasks",
  courierSupplierHub: "/operations/courier-supplier-hub",
  couriers: "/operations/couriers",
  createCourier: "/operations/couriers/create-courier",
  editCourier: (courierId = ":courierId") =>
    `/operations/couriers/${courierId}/edit`,
  returnsDashboard: "/operations/returns-dashboard",
  failedReturnsDashboard: "/operations/failed-returns-dashboard",
  nonDeliveryDates: "/operations/non-delivery-dates",
  expressHours: "/operations/express-hours",
  warehouseZones: "/operations/warehouse-zones",

  pickers: "/picking/pickers",
  createPicker: "/picking/pickers/create-picker",
  editPicker: (pickerId = ":pickerId") => `/picking/pickers/${pickerId}/edit`,
  missingTransactions: "/picking/missing-transactions",
  runsheetsDashboard: "/picking/runsheets-dashboard",
  pickerTab: "/picking/picker-tab",
  PickingSkuModal: (runsheetId = ":runsheetId", viewType = ":viewType") =>
    `/picking/pickingSkuModal/${runsheetId}/${viewType}`,
  pickingOrderModal: (runsheetId = ":runsheetId", viewType = ":viewType") =>
    `/picking/pickingOrderModal/${runsheetId}/${viewType}`,

  qualityReviewOrders: "/quality/review-orders",
  qualityTickets: "/quality/tickets",
  qualityReturnTickets: "/quality/return-tickets",
  qualityReturns: "/quality/returns",
  qualityNeedInvestigation: "/quality/need-investigation",
  qualityVoiceComplaints: "/quality/voice-complaints",
  reasons: "/quality/reasons",

  inventoryDashboard: `/inventory/dashboard`,
  consignment: `/inventory/consignment`,
  consignmentReturns: `/inventory/consignment-returns`,
  consignmentCustomerReturns: `/inventory/consignment-customer-returns`,
  saleOrdersDashboard: `/inventory/sale-orders-dashboard`,
  returnOrdersDashboard: `/inventory/return-orders-dashboard`,
  purchaseOrdersDashboard: `/inventory/purchase-orders-dashboard`,
  transferOrdersDashboard: `/inventory/transfer-orders-dashboard`,
  skusMissingCbm: `/inventory/skus-missing-cbm`,

  commercialInventoryDashboard: "/commercial/inventory/dashboard",
  repricingInventorySkus: "/commercial/repricing-inventory-skus",
  repricingRequests: "/commercial/repricing-requests",
  subCategoriesMargin: "/commercial/sub-categories-margin",
  requestedProducts: "/commercial/requested-products",
  requestsDetails: "/commercial/requests-details",
  commercialMapping: "/commercial/commercial-mapping",
  mtorAiMapping: "/commercial/mtor-ai-mapping",

  instaMartUsers: "/inst-parts/inst-parts-users",
  instaPartsPolygons: "/inst-parts/insta-parts-polygons",
  instaPartsReturnOrders: "/instaparts/instaparts-return-orders",
  instaPartsStockReturns: "/instaparts/instaparts-stock-returns",
  instaMartPos: "/instamart/instamart-pos",
  instaMartSos: "/instamart/instamart-sos",
  mechanicsDashboard: "/system-data/mechanics-dashboard",
  MECHANIC_CATEGORY: "/system-data/mechanic-category",
  MECHANIC_SEGMENT: "/system-data/mechanic-segment",
  MECHANIC_SIZE: "/system-data/mechanic-size",
  suppliersDashboard: "/system-data/suppliers-dashboard",
  carsDashboard: "/system-data/cars-dashboard",
  skusDashboard: "/system-data/skus-dashboard",
  skusPendingVerify: "/system-data/skus-pending-verify",
  skusReturnPendingVerify: "/system-data/skus-return-pending-verify",
  intersectionIds: "/system-data/intersection-ids",
  skusTargets: "/commercial/skus-targets",
  intersectionMatrix: "/system-data/intersection-matrix",
  brandFamiliesDashboard: "/system-data/brand-Families-dashboard",
  supplierPendingSkus: "/system-data/supplier-pending-skus",
  wrongFitmentTickets: "/system-data/wrong-fitment-tickets",
  banners: "/system-data/banners",

  skusEagleEye: "/pricing/skus-eagle-eye",
  pricingHistoryDashboard: "/pricing/pricing-history-dashboard",
  supplierSkusPrices: `/pricing/supplier-skus-prices`,

  notificationService: "/notification-service",
  scheduledNotifications: "/scheduled-notifications",
  suppliersNotification: "/notification/suppliers",
  mechanicsNotification: "/notification/mechanics",

  promotions: "/deals/promotions",
  bundles: "/deals/bundles",

  taxes: "/finance/taxes",
  instaPartsTaxes: "finance/instaPartsTaxes",
  courierWallet: "/finance/courier-wallet",
  mechanicWallet: "/finance/mechanic-wallet",
  supplierWallet: "/finance/supplier-wallet",
  supplierHubWallet: "/finance/financial-hub-wallet",
  mechanicCompensations: "/finance/mechanic-compensations",

  assets: "/it-management/assets",
  assetLogs: "/it-management/asset-logs",
  employees: "/it-management/employees",

  users: "/user-management/users",
  roles: "/user-management/roles",
  mechanicGrouping: "/user-management/mechanic-grouping",
};

// sideDrawer paths
const SIDE_DRAWER_PATHS = {
  ...SIDE_DRAWER_CHILDREN_PATHS,

  mainDashboard: "/",
  parentOrders: "/parent-orders",
  voiceOrders: "/voice-orders",
  voiceAppOrders: "/voice-app-orders",
  mechanicAppStockOrders: "/mechanic-app-stock-orders",
  mechanicAppPricingOrders: "/mechanic-app-pricing-orders",
  mySales: "/my-sales",
  vendor: "/vendor",
  tower: "/tower",
  operations: "/operations",
  picking: "/picking",
  quality: "/quality",
  inventory: "/inventory",
  systemData: "/system-data",
  pricing: "/pricing",
  chatRooms: "/chat-rooms",
  purchaseOrders: "/purchaseOrders",
  stockReturns: "/stockReturns",
  deepLinks: "/deep-links",
  notificationCenter: "/notification",
  deals: "/deals",
  finance: "/finance",
  commercial: "/commercial",
  itManagement: "/it-management",
  userManagement: "/user-management",
  gearbox: "/gearbox",
};

// paths for all pages
export const PATHS = {
  ...SIDE_DRAWER_PATHS,

  login: "/login",
  validate2fa: "/login/two-step-verification/authenticator",

  newOrder: salesWebsiteUrl,
  mechanicNewOrder: (mechanicId) =>
    `${salesWebsiteUrl}?mechanicId=${mechanicId}`,

  newOrderForVoiceOrder: (mechanicId, branchId, voiceOrderId) =>
    `${salesWebsiteUrl}?mechanicId=${mechanicId}&branchId=${branchId}&voiceOrderId=${voiceOrderId}`,

  followUpOrder: (orderId = ":orderId") =>
    `${salesWebsiteUrl}?createdFromOrderId=${orderId}`,

  editOrder: (orderId = ":orderId") => `/order/${orderId}/edit`,
  editStockReturn: (stockReturnOrderId = ":stockReturnOrderId") =>
    `/edit/stockReturnOrder/${stockReturnOrderId}`,

  orderProfile: (orderId = ":orderId", orderStatus = ":orderStatus") =>
    `/order/profile/${orderId}/${orderStatus}`,

  parentOrderProfile: (orderId = ":orderId", orderStatus = ":orderStatus") =>
    `/parent-order/profile/${orderId}/${orderStatus}`,

  pricingOrder: (orderId = ":orderId", supplierId = ":supplierId") =>
    `/order/${orderId}/pricing/supplier/${supplierId}`,

  opFormOrder: (orderId = ":orderId") => `/order/${orderId}/op-form`,

  purchaseOrderDetails: (orderId = ":orderId") =>
    `/inventory/purchase-order/details/${orderId}`,

  receiveFormDetails: (receiveFormId = ":receiveFormId") =>
    `/inventory/purchase-order/receive-form/details/${receiveFormId}`,

  requestPurchaseOrder: "/inventory/purchase-order/request-order",

  requestPurchaseOrderDetails: (purchaseOrderId = ":purchaseOrderId") =>
    `/inventory/purchase-order/request-order-details/${purchaseOrderId}`,

  transferOrder: (transferOrderId = ":transferOrderId") =>
    `/inventory/transfer-order/${transferOrderId}`,

  newTransferOrder: "/inventory/transfer-order/new-order",
  newStockReturnOrder: "/stockReturns/new-order",

  mechanicDetailsPage: (mechanicId = ":mechanicId") =>
    `/mechanic/${mechanicId}/details`,

  newCar: "/car/new-car",
  editCar: (carId = ":carId") => `/car/${carId}/edit`,
  createCarBrand: "/car/brand/create",
  editCarBrand: "/car/brand/edit",
  createCarModel: "/car/model/create",
  editCarModel: "/car/model/edit",
  createCarEngine: "/car-engine/create",

  newSupplier: "/supplier/new-supplier",

  editSupplier: (supplierId = ":supplierId") => `/supplier/${supplierId}/edit`,

  supplierDashboard: (supplierId = ":supplierId") =>
    `/supplier/${supplierId}/dashboard`,

  supplierDetailsPage: (supplierId = ":supplierId") =>
    `/supplier/${supplierId}/details`,

  newSku: "/sku/new-sku",

  editSku: (skuId = ":skuId") => `/sku/${skuId}/edit`,

  skuDetails: (skuId = ":skuId") => `/sku/${skuId}/details`,

  replicateSku: (skuId = ":skuId") => `/sku/${skuId}/replicate`,

  newSkuName: "/sku/name/new-name",

  editSkuName: "/sku/name/edit",

  newSkuBrand: "/sku/brand/new-brand",

  editSkuBrand: "/sku/brand/edit",

  newSkuCategory: "/sku/category/new-category",

  editSkuCategory: "/sku/category/edit",

  newSkuSubCategory: "/sku/subCategory/new-subCategory",

  editSkuSubCategory: "/sku/subCategory/edit",

  newSkuOrigin: "/sku/origin/new-origin",

  editSkuOrigin: "/sku/origin/edit",

  newSkuForSkuPending: (skuPendingId = ":skuPendingId") =>
    `/sku/sku-pending/${skuPendingId}/new-sku`,

  newSkuForSupplierSkuPending: (
    supplierSkuPendingId = ":supplierSkuPendingId"
  ) => `/sku/supplier-sku-pending/${supplierSkuPendingId}/new-sku`,

  newBrandFamily: "/brand-family/new-brand-family",

  editBrandFamily: (brandFamilyId = ":brandFamilyId") =>
    `/brand-family/${brandFamilyId}/edit`,

  newBanner: "/banner/new-banner",

  editBanner: (bannerId = ":bannerId") => `/banner/${bannerId}/edit`,

  newPromotion: "/promotion/new-promotion",

  newBundle: "/bundle/new-bundle",

  createScheduledNotification: "/scheduled-notifications/create",

  addRole: "/roles/new-role",
  editRole: (roleId = ":roleId") => `/role/${roleId}/edit`,

  addPolygons: "/polygons/new-polygons",

  newReason: "/reason/new-reason",

  editReason: (reasonId = ":reasonId") => `/reason/${reasonId}/edit`,

  updateMtorAiMapping: "/update-ai-mapping",

  receiveConsignmentOrder: (consignmentOrderId = ":consignmentOrderId") =>
    `/supplier/consignmentOrder/receive/${consignmentOrderId}`,

  viewConsignmentOrder: (consignmentOrderId = ":consignmentOrderId") =>
    `/supplier/consignmentOrder/view/${consignmentOrderId}`,

  viewConsignmentReturnOrder: (
    consignmentReturnOrderId = ":consignmentReturnOrderId"
  ) => `/supplier/consignmentReturnOrder/view/${consignmentReturnOrderId}`,
};
